module.exports = __webpack_public_path__ + "static/media/top_infographic_mobile.8932e387.webp";